import Component from 'inferno-component';
//import { Link, IndexLink } from 'inferno-router';
import { Responsive, Container } from "semantic-ui-react";

import MobileNavigation from './MobileNavigation';
import DesktopNavigation from './DesktopNavigation';

export default class Navigation extends Component {

  render() {
    const { children } = this.props;

    return(
      <div>
        <Responsive {...Responsive.onlyMobile}>
          <MobileNavigation>
            <Container fluid style={{marginLeft: '0 !important', marginRight: '0 !important'}}>{children}</Container>
          </MobileNavigation>
        </Responsive>

        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <DesktopNavigation />
          <Container fluid>{children}</Container>
        </Responsive>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/navigation/Navigation.js